import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Divider,
  Fade,
} from '@mui/material';
import UnifiedInvoiceDataDisplay from '../shared/components/InvoiceDataDisplay/UnifiedInvoiceDataDisplay';
import OrderDetailsSkeleton from '../shared/components/OrderDetailsSkeleton';

const OrderDetails = ({
  selectedOrder,
  invoiceData,
  printType,
  eanInputs,
  onEanInputChange,
  eanValidated,
  eanRefs,
  handleEanKeyDown,
  theme,
  invoiceLoading,
  printControls,
  bridgeAlert,
}) => {
  if (!selectedOrder) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: { xs: 2, md: 4 },
          borderRadius: 4,
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.disabled,
          border: `1.5px dashed ${theme.palette.divider}`,
          minHeight: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="subtitle1" color="text.disabled">
          Selecione um pedido para ver os detalhes
        </Typography>
      </Paper>
    );
  }

  if (invoiceLoading) {
    return (
      <Box 
        sx={{ 
          height: { xs: "auto", md: "calc(100vh - 200px)" },
          maxHeight: { xs: "auto", md: "calc(100vh - 200px)" }
        }}
      >
        <OrderDetailsSkeleton theme={theme} />
      </Box>
    );
  }

  return (
    <Fade in timeout={400}>
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: "column", 
          gap: 2,
          height: { xs: "auto", md: "calc(100vh - 200px)" },
          maxHeight: { xs: "auto", md: "calc(100vh - 200px)" }
        }}
      >
        <Paper
          elevation={6}
          sx={{
            p: { xs: 2, md: 4 },
            borderRadius: 4,
            bgcolor: theme.palette.background.paper,
            border: `1.5px solid ${theme.palette.warning.main}`,
            flex: 1,
            overflow: "auto",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
            <Typography
              variant="h6"
              color="warning.main"
              fontWeight={700}
            >
              Pedido selecionado:{" "}
              <b>
                {selectedOrder.content?.invoice_number || selectedOrder._id}
              </b>
            </Typography>
            {bridgeAlert}
          </Box>
          <Divider sx={{ mb: 2 }} />
          
          <UnifiedInvoiceDataDisplay
            invoiceData={invoiceData}
            visible={!!invoiceData}
            showEanField={printType === "detalhada"}
            eanInputs={eanInputs}
            onEanInputChange={onEanInputChange}
            eanValidated={eanValidated}
            eanRefs={eanRefs}
            onEanKeyDown={handleEanKeyDown}
          />
        </Paper>
        
        {printControls && (
          <Paper
            elevation={4}
            sx={{
              p: 2,
              borderRadius: 3,
              bgcolor: "background.paper",
              border: "1px solid rgba(255, 152, 0, 0.2)",
              position: "sticky",
              bottom: 0,
              zIndex: 10
            }}
          >
            {printControls}
          </Paper>
        )}
      </Box>
    </Fade>
  );
};

export default OrderDetails;